import { isInIframe, getParentData, sendInputMessageToParent, encodeKey } from './iframeUtils';

export class IframeLocalStorage {
  static getItem(key: string): string | null {
    if (isInIframe()) {
      return getParentData(encodeKey(key));
    }
    return localStorage.getItem(key);
  }

  static setItem(key: string, value: string): void {
    if (isInIframe()) {
      // Send update to parent
      sendInputMessageToParent({ [encodeKey(key)]: value });
    } else {
      localStorage.setItem(key, value);
    }
  }

  static removeItem(key: string): void {
    if (isInIframe()) {
      // Send removal to parent
      sendInputMessageToParent({ [encodeKey(key)]: null });
    } else {
      localStorage.removeItem(key);
    }
  }

  static clear(): void {
    if (isInIframe()) {
      // Send clear signal to parent
      sendInputMessageToParent({ clearAll: true });
    } else {
      localStorage.clear();
    }
  }
}

// Export a default instance that mimics localStorage API
export const iframeLocalStorage = {
  getItem: (key: string) => IframeLocalStorage.getItem(key),
  setItem: (key: string, value: string) => IframeLocalStorage.setItem(key, value),
  removeItem: (key: string) => IframeLocalStorage.removeItem(key),
  clear: () => IframeLocalStorage.clear(),
};
